var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.399902,
    width: 45,
    height: 45,
    rx: 4,
    fill: "url(#paint0_linear_2633_7659)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9864 26.3694L27.0489 24.6819C26.8807 24.6102 26.6937 24.5951 26.5162 24.6388C26.3386 24.6826 26.1801 24.7828 26.0645 24.9244L24.3207 27.0549C21.5841 25.7646 19.3817 23.5622 18.0914 20.8256L20.2219 19.0818C20.3638 18.9664 20.4642 18.8079 20.508 18.6303C20.5518 18.4526 20.5365 18.2656 20.4645 18.0974L18.777 14.1599C18.6979 13.9787 18.5581 13.8307 18.3816 13.7415C18.2051 13.6523 18.003 13.6274 17.8102 13.6713L14.1539 14.515C13.968 14.558 13.8021 14.6626 13.6834 14.812C13.5646 14.9613 13.5 15.1465 13.5 15.3373C13.5 24.3549 20.809 31.6498 29.8125 31.6498C30.0034 31.65 30.1886 31.5854 30.3381 31.4666C30.4875 31.3478 30.5922 31.1819 30.6352 30.9959L31.4789 27.3397C31.5225 27.1459 31.4971 26.943 31.4072 26.7659C31.3173 26.5888 31.1685 26.4486 30.9864 26.3694Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7659",
    x1: 39.2108,
    y1: 60.2994,
    x2: -15.0779,
    y2: 39.2056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.e4d0038b01ec043868d133f62bbff5e6.svg";
export { ForwardRef as ReactComponent };